import { render, staticRenderFns } from "./StallProfile.vue?vue&type=template&id=06b4fa36&scoped=true"
import script from "./StallProfile.vue?vue&type=script&lang=js"
export * from "./StallProfile.vue?vue&type=script&lang=js"
import style0 from "./StallProfile.vue?vue&type=style&index=0&id=06b4fa36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4fa36",
  null
  
)

export default component.exports